import { WeatherProduct } from '../products/products';
import { WeatherProductTimestamps } from '../weather-loader';
import { WeatherStoreProductInfo, WeatherStoreProductFrameInfo } from '../worker/store/weather-store';

export enum WeatherItemUpdateLate {
    no,
    yellow,
    red
}

export enum SelectedWeatherItemType {
    weather,
    global,
    static
}

export type ProductsChangedEventTypes = 'visibleFrameChanged' | 'addRemove' | 'visibility' | 'loaded' | 'reordered' | 'altitude';

export type WeatherProductFileInfo = {
    id: number;
    previous: WeatherProductTimestamps[];
    current: WeatherProductTimestamps;
};

export interface SelectedWeatherItem {
    id: number;
    visible: boolean;
    wms: boolean;
    gdf: boolean;
    type: SelectedWeatherItemType;
    loaded: boolean;
    success: boolean;
    error?: string;
    updateLate: WeatherItemUpdateLate;
    product: WeatherProduct;
    weatherStore?: WeatherStoreProductInfo;
    selectedFrame?: WeatherStoreProductFrameInfo;
}
